import { EProviderName, EProviderType, TOnboardingStatus, TPayment } from "swiipe.portal.shared"

export type TAcquirerName =
    | "Nets"
    | "Clearhaus"
    | "Forbrugsforeningen"
    | "Swish"
    | "Viabill"
    | "Anyday"
    | "Klarna"
    | "Resurs"
    | "Digiteal"
    | "VippsMobilePay"
    | "Area42"

export interface IGatewayProvider {
    paymentType: TPayment
    providerType: EProviderType
    providerName: EProviderName
    status?: TOnboardingStatus
    enabled?: boolean
}

export type IGatewayProvidersHandledByPaymentsApiConfig = {
    paymentType: TPayment
    providerType: EProviderType
    providerName: EProviderName
}[]

export const gatewayProvidersHandledByPaymentsApiConfig: IGatewayProvidersHandledByPaymentsApiConfig = [
    { paymentType: "Viabill", providerName: "Viabill", providerType: "PspAndAquirer" },
    { paymentType: "Anyday", providerName: "Anyday", providerType: "PspAndAquirer" },
    { paymentType: "CreditCard", providerName: "Digiteal", providerType: "Psp" },
    { paymentType: "Bancontact", providerName: "Digiteal", providerType: "Psp" },
    { paymentType: "Ideal", providerName: "Digiteal", providerType: "Psp" },
    { paymentType: "Vipps", providerName: "VippsMobilePay", providerType: "PspAndAquirer" },
    { paymentType: "AccountToAccount", providerName: "AccountToAccount", providerType: "PspAndAquirer" },
    { paymentType: "ResursInvoice", providerName: "Resurs", providerType: "PspAndAquirer" },
    { paymentType: "ResursPartPayment", providerName: "Resurs", providerType: "PspAndAquirer" },
    { paymentType: "ResursRevolvingCredit", providerName: "Resurs", providerType: "PspAndAquirer" },
    { paymentType: "TermsTech", providerName: "Area42", providerType: "PspAndAquirer" },
]
